export default __webpack_public_path__ + "static/media/coaster.d014ca8f.jpg";